import React from "react"
import { Redirect } from "react-router-dom"

// User profile
import UserProfile from "../pages/Authentication/UserProfile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
/**
 * pages ganjil
 */
import Orders from "pages/Orders"
import OrdersCreate from "pages/Orders/Create"
import OrdersEdit from "pages/Orders/Edit"
import OrdersEditRepair from "pages/Orders/EditRepair"
import InpectionBespoke from "pages/Inspection/Bespoke"
import InpectionRTW from "pages/Inspection/RWT"
import OrderSheetCreation from "pages/OrderSheetCreation"
import EnterpriseCustomerManagement from "pages/EnterpriseCustomerManagement"
import IndividualCustomerManagement from "pages/IndividualCustomerManagement"
import Administrator from "pages/Administrator"
import AdministratorCreate from "pages/Administrator/Create"
import AdministratorEdit from "pages/Administrator/Edit"
import MasterCategories from "pages/Master/Categories"
import MasterProducts from "pages/Master/Products"
import MasterSpecification from "pages/Master/Specification"
import MasterDimension from "pages/Master/Dimension"
import MasterCorrection from "pages/Master/Correction"
import MasterRTWSeason from "pages/Master/RTW-Season"
import MasterRTWProduct from "pages/Master/RTW-Product"
import MasterRTWHandwrittenImage from "pages/Master/RTW-Handwritten-Image"
import MasterDough from "pages/Master/Dough"
import MasterFabricTradingCompany from "pages/Master/Fabric-Trading-Company"
import ArrangementBeSpoke from "pages/Arrangement/Bespoke"
import ArrangementRTW from "pages/Arrangement/RTW"
import ProductionAmount from "pages/ProductionAmount"
import RetailList from "pages/RetailList"
import RetailListCreate from "pages/RetailList/Create"
import RetailListEdit from "pages/RetailList/Edit"
import RtwInventoryManagement from "pages/InventoryControl/RTWInventoryManagement"
import FabricPurchaseManagement from "pages/InventoryControl/FabricPurchaseManagement"
import FabricInventoryManagement from "pages/InventoryControl/FabricInventoryManagement"
import DirectManagement from "pages/DirectManagement"
import EnterpriseCompany from "pages/EnterpriseCustomerManagement/EnterpriseCompany"
import BrandCompany from "pages/EnterpriseCustomerManagement/BrandCompany"
import DetailIgarashi from "pages/DirectManagement/DetailIgarashi"
import DetailOther from "pages/IndividualCustomerManagement/DetailOther"
import CreateFabric from "pages/Master/Dough/Create"
import EditFabric from "pages/Master/Dough/Edit"
import CreateFabricTrading from "pages/Master/Fabric-Trading-Company/Create"
import EditFabricTrading from "pages/Master/Fabric-Trading-Company/Edit"
import CategoryManagement from "pages/Master/Categories/category"
import ProductManagement from "pages/Master/Products/product"
import DetailRtwProduct from "pages/Master/RTW-Product/Detail"
import DetailSeason from "pages/Master/RTW-Season/Detail"
import DetailRtwImage from "pages/Master/RTW-Handwritten-Image/Detail"
import SpecificationManagement from "pages/Master/Specification/specification"
import DetailDimension from "pages/Master/Dimension/Detail"
import DetailCorrection from "pages/Master/Correction/Detail"
import NewOrderSheets from "pages/OrderSheetCreation/NewOrderSheets"
import DetailAttendance from "pages/Dashboard/Detail"
import DirectManagementHistory from "pages/DirectManagement/History"
import IndividualCustomerManagementhistory from "pages/IndividualCustomerManagement/History"
import EnterpriseCustomerManagementHistory from "pages/EnterpriseCustomerManagement/History"
import DetailFabricPurchaseManagement from "pages/InventoryControl/FabricPurchaseManagement/Detail"
import DetailFabricInventory from "pages/InventoryControl/FabricInventoryManagement/Detail"
import CorporateOrders from "pages/CorporateOrders"
import CorporateOrderCreate from "pages/CorporateOrders/Create"
import CorporateOrdersEdit from "pages/CorporateOrders/Edit"
import DetailRtwInventoryManagement from "pages/InventoryControl/RTWInventoryManagement/Detail"
import Konva from "pages/Konva"

const authProtectedRoutes = [
  { path: "/attendance-management", component: Dashboard },
  {
    path: "/attendance-management/:date/:staffId?",
    component: DetailAttendance,
  },
  { path: "/orders", component: Orders },
  { path: "/orders/create", component: OrdersCreate },
  { path: "/orders/edit", component: OrdersEdit },
  { path: "/orders/edit/repair", component: OrdersEditRepair },
  { path: "/inspection/bespoke", component: InpectionBespoke },
  { path: "/inspection/rtw", component: InpectionRTW },
  { path: "/order-sheet-creation", component: OrderSheetCreation },
  { path: "/order-sheet-creation/form", component: NewOrderSheets },
  { path: "/arrangement/bespoke", component: ArrangementBeSpoke },
  { path: "/arrangement/rtw", component: ArrangementRTW },
  { path: "/production-amount", component: ProductionAmount },
  { path: "/retail-list", component: RetailList },
  { path: "/retail-list/create", component: RetailListCreate },
  { path: "/retail-list/edit", component: RetailListEdit },
  { path: "/corporate-orders", component: CorporateOrders },
  { path: "/corporate-orders/create", component: CorporateOrderCreate },
  { path: "/corporate-orders/edit", component: CorporateOrdersEdit },
  {
    path: "/enterprise-customer-management",
    component: EnterpriseCustomerManagement,
  },
  {
    path: "/enterprise-customer-management/company",
    component: EnterpriseCompany,
  },
  {
    path: "/enterprise-customer-management/brand/:id",
    component: BrandCompany,
  },
  {
    path: "/enterprise-customer-management/brand/:id/history",
    component: EnterpriseCustomerManagementHistory,
  },

  {
    path: "/individual-customer-management",
    component: IndividualCustomerManagement,
  },
  {
    path: "/individual-customer-management/:id",
    component: DetailOther,
  },
  {
    path: "/individual-customer-management/:id/history",
    component: IndividualCustomerManagementhistory,
  },
  {
    path: "/direct-management-individual-customer-management",
    component: DirectManagement,
  },
  {
    path: "/direct-management-individual-customer-management/:id",
    component: DetailIgarashi,
  },
  {
    path: "/direct-management-individual-customer-management/:id/history",
    component: DirectManagementHistory,
  },
  { path: "/administrator", component: Administrator },
  { path: "/administrator/create", component: AdministratorCreate },
  { path: "/administrator/:id", component: AdministratorEdit },
  { path: "/master/product-category", component: MasterCategories },
  { path: "/master/product-category/create", component: CategoryManagement },
  { path: "/master/product", component: MasterProducts },
  { path: "/master/product/create", component: ProductManagement },
  { path: "/master/specification", component: MasterSpecification },
  { path: "/master/specification/create", component: SpecificationManagement },
  { path: "/master/dimension", component: MasterDimension },
  { path: "/master/dimension/:id", component: DetailDimension },
  { path: "/master/correction", component: MasterCorrection },
  { path: "/master/correction/:id", component: DetailCorrection },
  { path: "/master/rtw-season", component: MasterRTWSeason },
  { path: "/master/rtw-season/:id", component: DetailSeason },
  { path: "/master/rtw-product", component: MasterRTWProduct },
  { path: "/master/rtw-product/:id", component: DetailRtwProduct },
  {
    path: "/inventory-control/fabric-inventory-management",
    component: FabricInventoryManagement,
  },
  {
    path: "/inventory-control/fabric-inventory-management/:id",
    component: DetailFabricInventory,
  },
  {
    path: "/inventory-control/fabric-purchase-management",
    component: FabricPurchaseManagement,
  },
  {
    path: "/inventory-control/fabric-purchase-management/:id",
    component: DetailFabricPurchaseManagement,
  },
  {
    path: "/inventory-control/rtw-inventory-management",
    component: RtwInventoryManagement,
  },
  {
    path: "/inventory-control/rtw-inventory-management/:productId/:size",
    component: DetailRtwInventoryManagement,
  },
  {
    path: "/master/rtw-handwritten-image",
    component: MasterRTWHandwrittenImage,
  },
  { path: "/master/rtw-handwritten-image/:id", component: DetailRtwImage },

  {
    path: "/master/dough",
    component: MasterDough,
  },
  {
    path: "/master/dough/create",
    component: CreateFabric,
  },
  {
    path: "/master/dough/:id",
    component: EditFabric,
  },
  {
    path: "/master/fabric-trading-company",
    component: MasterFabricTradingCompany,
  },
  {
    path: "/master/fabric-trading-company/create",
    component: CreateFabricTrading,
  },
  {
    path: "/master/fabric-trading-company/:id",
    component: EditFabricTrading,
  },
  //profile
  { path: "/profile", component: UserProfile },
  { path: "/order-sheet-creation/canvas", component: Konva },

  // this route 職人種類をもう一度ご確認ください at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/attendance-management" />,
  },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
]

export { authProtectedRoutes, publicRoutes }
